import { RefObject, useCallback, useRef, useState } from 'react';

export type ContextDropdownListState = {
  ref: RefObject<HTMLDivElement>;
  x: number;
  y: number;
  width: number;
  height: number;
};

export function useContextDropdownList() {
  const contextDropdownListRef = useRef<HTMLDivElement>(null);

  const [contextDropdownListState, setContextDropdownLostState] = useState<
    ContextDropdownListState | false
  >(false);

  const onCloseDropdownList = useCallback((e?: UIEvent) => {
    if (
      e?.type === 'wheel' &&
      e.composedPath().includes(contextDropdownListRef.current as EventTarget)
    ) {
      return;
    }

    setTimeout(() => {
      setContextDropdownLostState(false);
    }, 250);

    window.removeEventListener('resize', onCloseDropdownList, true);
    document.removeEventListener('click', onCloseDropdownList, true);
    document.removeEventListener('wheel', onCloseDropdownList, true);
    document.removeEventListener('touchmove', onCloseDropdownList, true);
  }, []);

  const onOpenDropdownList = useCallback(
    (e: UIEvent) => {
      e.stopPropagation();
      e.preventDefault();

      const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();

      setTimeout(() => {
        setContextDropdownLostState({
          ref: contextDropdownListRef,
          x: rect.left,
          y: rect.top,
          width: rect.width,
          height: rect.height,
        });
      }, 250);

      window.addEventListener('resize', onCloseDropdownList, true);
      document.addEventListener('click', onCloseDropdownList, true);
      document.addEventListener('wheel', onCloseDropdownList, true);
      document.addEventListener('touchmove', onCloseDropdownList, true);
    },
    [onCloseDropdownList]
  );

  return {
    contextDropdownListRef,
    contextDropdownListState,
    onOpenDropdownList,
    onCloseDropdownList,
  };
}
